// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"571":"c207d805","726":"126ccbbf"}[chunkId] + ".chunk.css";
};